
<template>
  <div>
    <banner></banner>
    <div class="domain-transform auto">
      <div class="goods-info ">
        <div class="goods-info-header fix">
          <div class="fl mr20">
            <img src="../static/assets/domain-transform-logo_03.png"
                 alt="">
          </div>
          <div class="pt10 f24 color3 ml90"
               style="height:32px;"><span class="title">选择中企，享受专业、品质服务</span></div>
          <div class="f14 mt16 color9 ml90">
            中企动力ICANN和CNNIC双重认证的顶级域名注册服务机构，百万企业客户的共同选择
          </div>
        </div>
        <div class="fix pt20">
          <div class="domain-inp fl">
            <textarea v-model="textarea"
                      class="domain-input"
                      rows="20"
                      @focus="hiddenPlaceholder"
                      @blur="showPlaceholder"></textarea>
            <div class="placeholder"
                 @click="focusTextarea"
                 v-if="textarea.length == 0">
              <div>请输入域名 + 英文逗号 + 转移密码 + 回车 如：</div>
              <div>300.cn,password1</div>
              <div>300.com,password2</div>
            </div>
            <button class="domain-inp-btn"
                    :disabled="textarea.length == 0 || isOverLength>20 || checkDomainBtnIsLoading"
                    :class="{'primary-btn':textarea.length>0 && isOverLength<=20 && !checkDomainBtnIsLoading}"
                    @click="transform">立即转入</button>
            <span class="fr overlength red"
                  v-if="isOverLength>20">最多输入20个域名，已经超出{{isOverLength-20}}个。</span>
          </div>
          <div class="domain-inp-tip fr">
            <div class="mb23">域名转入填写规则：</div>
            <ol class="f12 color9">
              <li class="lh22">1.请输入域名和正确的转移密码，以英文逗号间隔。每行一组域名、转移密码，回车结尾</li>
              <li class="lh22">2.如转入域名较多，建议使用Excel、word等软件编辑保存，复制后按
                【ctrl+v】粘贴至下方列表中。</li>
              <li class="lh22">3.在线转入支持20个以内域名批量转入。</li>
            </ol>
            <div class="primary-color f12 mt15">注：域名转移密码需在原域名注册商处获取。</div>
          </div>
        </div>
        <div id="mao"></div>
        <div class="tc f14 wait"
             v-show="errorList.length == 0 && cartGroupList.length == 0 && showLoading">
          域名状态查询中，请稍候...
        </div>
        <div class="transform-error transform-result"
             v-if="errorList.length>0">
          <div class="transform-error-header transform-header">
            <img src="../static/assets/dis-transform_03.png"
                 class="transform-status-icon dib dis"></img><span class="f14 color6">不可转入域名</span>
            <span class="f12">
              （共有 <i class="color9 n">{{errorList.length}}</i>个）
            </span>
          </div>
          <el-table :data="errorList"
                    border
                    style="width: 100%">
            <el-table-column prop="domain"
                             label="域名"
                             width="160">
            </el-table-column>
            <el-table-column prop="msg"
                             label="失败原因">
            </el-table-column>
          </el-table>

        </div>
        <div class="transform-allow transform-result"
             v-if="cartGroupList.length>0">
          <div class="transform-allow-header transform-error-header">
            <img src="../static/assets/allow-transform_03.png"
                 class="transform-status-icon dib allow"></img><span class="color6">可转入域名</span>
            <span class="f12">
              （共有 <i class="color9 n">{{cartGroupList.length}}</i>个）
            </span>
            <div class="mt15">
              <el-tag v-for="(tag,index) in cartGroupList"
                      :key="index"
                      closable
                      @close="delDomain(tag)"
                      :type="tag.type">
                {{tag.domain}}
              </el-tag>
            </div>

          </div>
          <div class="transform-allow-tip mb30" style="background: #fff9e2;padding: 20px;">
            <p class="f12"> 温馨提示：</p>
            <p>（1）如您选择了默认模板或已实名信息模板转入的域名，除.com/.net/.cn/.中国外其他域名均需做在域名管理进行实名制操作。</p>
            <p>（2）如您选择了原注册默认信息转入的域名均需在域名管理提交实名制对于没有操作实名制的域名，注册局可能会对域名进行禁止解析操作，为避免影响您的使用，请及时更新操作！</p>
          </div>
          <div class="domain-template">
            <div class="domain-template-header"
                 v-if="templateList.length != 0">
              <p>请选择域名转入模板</p>
              <div class="primary-color"
                   @click="addNewTemplate"
                   style="position:absolute;right:0;top: 0;cursor:pointer; ">创建新的域名信息模板</div>
            </div>

            <div style="position: relative;">
              <div class="selban">
                <label v-for="(item,i) in templateList"
                       :key="i"
                       :class="{user:item.registrantType==='I'}">
                  <input type="radio"
                         :value="item.id"
                         v-model="domainTemplateId">{{item.templateName}}
                  <em>{{item.registrantTypeLabel}}注册信息</em>

                  <el-button type="text"
                             @click="item.dialogVisible = true">详情</el-button>

                  <el-dialog title="域名模板详情"
                             :visible.sync="item.dialogVisible"
                             width="40%">
                    <span class="dgcon-list">
                      <p>
                        <i>模板名称</i>
                        <b>{{item.templateName}}</b>
                      </p>
                      <p>
                        <i>所有者类型</i>
                        <b>{{item.apiType}}</b>
                      </p>
                      <p>
                        <i>域名所有者(中文)</i>
                        <b>{{item.nameCn}}</b>
                      </p>
                      <p>
                        <i>域名所有者(英文)</i>
                        <b>{{item.nameEn}}</b>
                      </p>
                      <p>
                        <i>资料认证状态</i>
                        <b>{{item.status}}</b>
                      </p>
                      <p>
                        <i>域名联系人(中文)</i>
                        <b>{{item.custLinkmanCn}}</b>
                      </p>
                      <p>
                        <i>域名联系人(英文)</i>
                        <b>{{item.custLinkmanEn}}</b>
                      </p>
                      <p>
                        <i>所属区域</i>
                        <b></b>
                      </p>
                      <p>
                        <i>省份(英文)</i>
                        <b>{{item.provinceEn}}</b>
                      </p>
                      <p>
                        <i>城市(英文)</i>
                        <b>{{item.cityEn}}</b>
                      </p>
                      <p>
                        <i>通讯地址(中文)</i>
                        <b>{{item.addressCn}}</b>
                      </p>
                      <p>
                        <i>通讯地址(英文)</i>
                        <b>{{item.addressEn}}</b>
                      </p>
                      <p>
                        <i>邮政编码</i>
                        <b>{{item.zipCode}}</b>
                      </p>
                      <p>
                        <i>电话</i>
                        <b>{{item.tel}}</b>
                      </p>
                      <p>
                        <i>手机号码</i>
                        <b>{{item.cellPhoneNumber}}</b>
                      </p>
                      <p>
                        <i>电子邮箱</i>
                        <b>{{item.email}}</b>
                      </p>
                    </span>
                    <span slot="footer"
                          class="dialog-footer">
                      <el-button @click="item.dialogVisible = false">关闭</el-button>
                    </span>
                  </el-dialog>
                </label>
              </div>
              <div class="domain-template-item"
                   v-if="templateList.length == 0">
                <div>亲，没有查询到可用的信息模板，请去
                  <a class="primary-color"
                     @click="addNewTemplate"
                     href="javascript:;">创建信息模版</a> 。（转入域名时，必须使用已实名认证的模版）</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt30"
             v-if="cartGroupList.length>0">
          <el-checkbox v-model="allowAgreement">我已阅读，理解并同意<a href="javascript:;"
               @click="potocalVisible = true"
               style="color: #108ee9;">《中企域名转移服务协议》</a>
          </el-checkbox>
        </div>
        <div class="mt20 mt40"
             v-if="cartGroupList.length>0">
          <el-button type="primary"
                     @click="save"
                     :loading="nextButtonIsLoading">下一步</el-button>
        </div>

      </div>
      <div class="goods-desc mt10">
        <domain-transform-tabs></domain-transform-tabs>
      </div>
      <el-dialog title="中企域名转移服务协议"
                 :visible.sync="potocalVisible"
                 width="50%"
                 :center="true"
                 :before-close="handleClose">
        <domain-transform-agreement></domain-transform-agreement>

      </el-dialog>
    </div>
  </div>

</template>
<script>
import suffix1 from '../static/assets/suffix1'
import suffix2 from '../static/assets/suffix2'
import suffix3 from '../static/assets/suffix3'

import banner from './components/header'
import domainTransformTabs from './components/domain-transform-tabs'
import domainTransformAgreement from './components/domain-transform-agreement'
import { win32 } from 'path';

export default {
  data () {
    return {
      showLoading: false,
      nextButtonIsLoading: false,
      potocalVisible: false,
      visible: false,
      textarea: '',
      errorDomainCount: 0,
      tags: [],
      templateList: [],
      allowAgreement: false,
      activeName: 'first',
      locationErrorList: [],
      postDomainList: '',
      domainSuffix: '',
      errorList: [],
      cartGroupList: [],
      form: {
        registrantType: 'E',
        nameCn: '',
        nameEn: '',
        email: '',
        source: '3'
      },
      checkedTemplate: '',
      domainTemplateId: '',
      checkDomainBtnIsLoading: false,
      acceptAgreement: ''
    }
  },
  components: {
    domainTransformTabs,
    banner,
    domainTransformAgreement
  },
  created () {
    window.sessionStorage.removeItem("domainTransformCache")

  },
  computed: {
    isOverLength () {
      let inputStr = this.textarea.trim()
      inputStr = inputStr.replace(/(\r\n|\n|\r)/ig, ';')
      let rows = inputStr.split(";")
      return rows.length || 0
    }
  },
  methods: {
    addNewTemplate () {
      window.open(__vipOrderDomainUrl + '/domainCenter/template/template/editInfo')
    },
    focusTextarea ($event) {
      // let e = document.createEvent("MouseEvents");
      // e.initEvent("focus", true, true);
      document.querySelector(".domain-input").focus()
    },
    hiddenPlaceholder () {
      $(".placeholder").addClass("dn")
    },
    showPlaceholder () {
      $(".placeholder").removeClass("dn")
    },
    delDomain (item) {
      this.cartGroupList = this.cartGroupList.filter(ele => {
        return ele.domain != item.domain
      })
    },
    handleClose () {
      this.potocalVisible = false
    },
    save () {
      if (!this.allowAgreement) {
        this.$msgbox({
          // title:'',
          type: 'error',
          message: '请先同意《中企域名转移服务协议》'
        })
        return
      }

      if (!this.cartGroupList || this.cartGroupList.length === 0) {
        this.$msgbox({
          type: 'error',
          message: '没有选中任何域名！'
        })
        return
      }

      if (!this.domainTemplateId || this.domainTemplateId === 'newDomainInfo') {
        this.$msgbox({
          type: 'error',
          message: '没有选中任何域名模板！'
        })
        return
      }

      const cartGroupList = this.cartGroupList.map(v => {
        return {
          cartGroupId: v.cartGroupId,
          cartGroupInfo: {
            TIME_LONG: v.timeLong,
            serviceGoodsId: v.serviceGoodsId
          }
        }
      })
      let postData = []
      this.cartGroupList.forEach(ele => {

        postData.push({
          domainInputInfo: {
            "domainName": ele.domainName.toLowerCase(),           // String
            "domainSuffix": ele.domainSuffix,              // String
            "domainPassword": ele.password,        // String
            "domainMaxTimeLong": ele.maxTime,            // Integer
            "domainTemplateId": this.domainTemplateId     // String
          },
          "businessType": "1", //售卖类型
          "source": "AFFICIAL_WEBSITE", //来源
          "skuId": ele.skuId,// skuId
          "goodsNum": 1, //是否支持时长或数量
          "timeLong": "1", // 是否支持时长或数量
          "LANGUAGE": ele.LANGUAGE || '',
          "isSyncMainTime": false
        })
      })
      this.nextButtonIsLoading = true
      window.sessionStorage.setItem("domainTransformCache", JSON.stringify(postData))

      this.$router.push({
        path: '/domain/domain-transform-register',
      })

      //
    },
    changeChecked (v) {
      this.acceptAgreement = v
    },
    getDomainTemplateList () {
      this.templateList = []
      this.domainTemplateId = ''
      $.get(`/security/domainTemplate/list`, { status: 'C', bussinessType: 'TRANS_IN' }).then(
        response => {
          if (response && Array.isArray(response.domainTemplateList)) {
            this.templateList = response.domainTemplateList.map(v => {
              v.dialogVisible = false
              return v
            })
          }
          this.domainTemplateId =
            (this.templateList[0] && this.templateList[0].id) || 'newDomainInfo'
        }
      )
    },
    validate (domainPwd) {
      domainPwd = domainPwd.trim()
      if (!domainPwd) return false
      let domainSplit = domainPwd.split(",")
      return (Array.isArray(domainSplit) && domainSplit.length == 2 && domainSplit[0] && domainSplit[1])
    },
    transform () {
      this.showLoading = true
      this.errorList = []
      this.cartGroupList = []
      this.locationErrorList = []
      let domainPwdArr = []
      let domainArr = []
      let inputStr = this.textarea.trim()
      inputStr = inputStr.replace(/(\r\n|\n|\r)/ig, ';')
      domainPwdArr = inputStr.split(";")
      if (Array.isArray(domainPwdArr)) {
        let noRepeatDomainPwdArr = []
        // 去重
        domainPwdArr.forEach(ele => {
          if (noRepeatDomainPwdArr.indexOf(ele) == -1) {
            noRepeatDomainPwdArr.push(ele)
          }
        })
        // 跳转到锚点
        window.location.href = window.location.protocol + '//' + window.location.host + '/domain/domain-transform#mao'
        let promiseArr = []

        noRepeatDomainPwdArr.forEach(v => {
          // 能否通过本地校验
          if (this.validate(v)) {
            this.postDomainList += v
            promiseArr.push(this.getDomainData(v))
          } else {
            // 本地校验错误的结果
            this.locationErrorList.push(v)
            this.showLoading = false
          }
        })
        Promise.all(promiseArr).then((result) => {
          this.checkDomainBtnIsLoading = false
        }).catch((err) => {
          this.checkDomainBtnIsLoading = false
        });
        this.getDomainTemplateList()
      }
      this.locationErrorList.forEach(ele => {
        this.errorList.push({
          domain: ele,
          msg: '域名或转移密码格式不正确'
        })
      })
    },
    getDomainData (val) {
      this.checkDomainBtnIsLoading = true
      return new Promise((resolve, reject) => {
        $.get('/security/domainTransfer/domainTransferInCheck', { domainInfo: val }).then(
          res => {
            this.domainList = res.data
            if (Array.isArray(res.canNotTransfer)) {
              this.errorList = [].concat(this.errorList, res.canNotTransfer)
            }
            if (Array.isArray(res.canTransfer)) {
              this.cartGroupList = [].concat(this.cartGroupList, res.canTransfer)
              resolve(val + '已返回')
            }
            this.loadingDomainData = false
            this.showLoading = false

            reject(val + '返回失败')
          },
          err => {
            this.loadingDomainData = false
            reject(val + '返回失败')
          }
        )
      }
      )
    }

  }
}
</script>

<style  lang="scss">
@import "../static/css/domain-transform.scss";
</style>



// WEBPACK FOOTER //
// src/domain-transform.vue